import FooterDownloads from "components/FooterDownloads";
import FooterLinks from "components/FooterLinks";
import React from "react";

interface FooterProps {
    shouldShowDownloads?: boolean;
}

const Footer: React.FC<FooterProps> = ({ shouldShowDownloads }) => {
    return (
        <footer>
            {shouldShowDownloads ? <FooterDownloads /> : <></>}
            <FooterLinks />
        </footer>
    );
};

export default Footer;
